<template>
    <vue-scroll class="forgot-password-page align-vertical">
        <div class="form-wrapper align-vertical-middle">
            <div class="form-box card-base card-shadow--extraLarge">
                <img class="image-logo" :src="logo" alt="logo" />

                <template v-if="success">
                    <el-alert
                        class="text-center"
                        title="Please check your email for the password reset link."
                        type="success"
                        :closable="false"
                        center
                        show-icon
                    >
                    </el-alert>
                </template>
                <template v-else>
                    <form @submit.prevent="sendResetLink()">
                        <float-label class="styled">
                            <input
                                type="email"
                                placeholder="E-mail"
                                v-model="form.email"
                            />
                            <form-feedback :form="form" field="email" />
                        </float-label>

                        <div class="flex text-center center pt-20 pb-10">
                            <el-button
                                type="submit"
                                plain
                                size="small"
                                :loading="form.busy"
                                @click="sendResetLink()"
                                icon="mdi mdi-send"
                                class="send-btn tada animated"
                            >
                                SEND RESET LINK
                            </el-button>
                        </div>
                    </form>
                </template>
            </div>
        </div>
    </vue-scroll>
</template>

<script>
import * as Getters from "../../../store/constants/getters";

export default {
    name: "ForgotPassword",
    data() {
        return {
            form: new Form({
                email: null,
            }),
            success: false,
        };
    },
    computed: {
        logo() {
            return this.$store.getters[Getters.GET_LOGO];
        },
    },
    methods: {
        sendResetLink() {
            App.post(`/password/email`, this.form).then(() => {
                this.success = true;
            });
        },
    },
};
</script>

<style lang="scss">
@import "../../../../assets/scss/variables";

.forgot-password-page {
    background: $corwin-green;
    margin-left: -30px;
    margin-right: -30px;

    .form-wrapper {
        width: 100%;
    }

    .form-box {
        width: 100%;
        max-width: 340px;
        padding: 30px;
        box-sizing: border-box;
        margin: 20px auto;

        a {
            font-size: 14px;
            color: $text-color-accent;
            text-decoration: none;
            font-weight: 500;
        }

        .image-logo {
            width: 80px;
            margin: 0px auto;
            margin-bottom: 50px;
            display: block;
        }

        .send-btn {
            /*width: 160px;*/
        }
    }
}

@media (max-width: 768px) {
    .layout-container .container .view.forgot-password-page {
        margin-left: -5px;
        margin-right: -5px;
        max-width: calc(100% + 10px);
    }
}
</style>
